import { api } from '../api';
import { Group } from '../types/group';
import { useQuery, UseQueryResult } from 'react-query';
import { GetResponseBody } from '../types/api-response';
import { isMock } from '../utilities/is-mock';

export type GetGroupsResponse = {
    groups: Group[];
    totalItems: number;
};

type UseGroupsConfig = {
    page: number;
    limit?: number;
    search: string;
    sort: string;
    filter: string;
};

async function getGroups({ page, limit, search, sort, filter }: UseGroupsConfig): Promise<GetGroupsResponse> {
    const query = isMock()
        ? `filter=${filter}&page=${page}&sort=${sort}&search=${search}&limit=${limit}`
        : `${filter}&page=${page}&${sort}&search=${encodeURIComponent(search)}&limit=${limit}`;
    const { data } = await api.get(`/groups?${query}`);

    return data;
}

export function useGroups({ page, limit, search, sort, filter }: UseGroupsConfig): UseQueryResult<GetGroupsResponse, unknown> {
    return useQuery(['groups', page, limit, search, sort, filter], () => getGroups({ page, limit, search, sort, filter }), {
        keepPreviousData: true,
        retry: false,
    });
}
